'use strict';

angular.module('TurneroApp').component('coTurnocomentarios', {
	bindings: {
		idTurno: '<',
		onModal: '<'
	}, controller: [
		 'turnosService',
		 '$anchorScroll',
		 '$mdDialog',
		 'utilsService',
		 function (turnosService, $anchorScroll, $mdDialog, utilsService) {
		 	var ctrl = this;
		 	ctrl.nuevoComentario = new turnosService();

		 	ctrl.limpiarMemoria = function () {
		 		ctrl.nuevoComentario = new turnosService();
		 	}

		 	ctrl.$onChanges = function () {
		 		ctrl.nuevoComentario.Comentario_Texto = '';
		 		if (ctrl.idTurno) {
		 			ctrl.reloadComentarios(ctrl.idTurno);
		 		}
		 	};

		 	ctrl.reloadComentarios = function (id_turno) {
		 		utilsService.swalTitle('Obteniendo comentarios', 'info')
		 		turnosService.Get_Comentario_Historial({ 'id_turno': id_turno }).$promise.then(function (data) {
		 			ctrl.historial_Comentarios = data.Data;
		 			ctrl.nuevoComentario.Id_Turno = id_turno;
		 			swal.close();
		 		}).catch(function (error) {
		 			utilsService.errores(error);
		 		});

		 	};

		 	ctrl.postComentario = function () {
		 		turnosService.Post_Comentario(ctrl.nuevoComentario).$promise.then(function (data) {
		 			ctrl.nuevoComentario.Comentario_Texto = '';
		 			ctrl.reloadComentarios(ctrl.nuevoComentario.Id_Turno);

		 		}).catch(function (error) {
		 			utilsService.errores(error);
		 		});
		 	}
		 	ctrl.cerrarModal = function () {
		 		$mdDialog.destroy();
		 	}
		 }
	],
	template: require('./turnoComentario.html')
});



// WEBPACK FOOTER //
// ./app/components/turnos/turnoComentarioComponent.js